import React, {useEffect, useState} from "react"
import {useSessionCookie} from "../hooks/useSessionCookie";
import {createContext} from "react";
import {useAsync} from "../hooks/useAsyncResult";
import {getActiveSubscription} from "../services/api/subscription";
import {Subscription} from "../models/subscription";
import {User} from "../models/user";
import {useTranslation} from "react-i18next";
import {storedLanguage, storeLanguage} from "../localization";

export const ILanguageContext = createContext<LanguageContextState>({})

export type LanguageContextState = {
    lang?: string
    setLanguage?: (lang: string) => void
}

const LanguageContext = (props: { children }) => {
    const {userSession} = useSessionCookie()
    const [language, setLanguageState] = useState<string>(storedLanguage())
    const {i18n} = useTranslation()

    const setLanguage = (lang: string) => {
        setLanguageState(lang)
        storeLanguage(lang)
        i18n.changeLanguage(lang)
    }

    useEffect(() => {
        const lang = userSession?.currentUser?.language
        // A signed-in user's saved language wins over whatever was picked as a guest.
        if (lang) setLanguage(lang)
    }, [userSession, i18n])

    return <ILanguageContext.Provider value={{
        lang: language,
        setLanguage
    }}>
        {props.children}
    </ILanguageContext.Provider>
}

export default LanguageContext